import { gettext } from "./i18n.js"

export function NotFound() {
  return (
    <div>
      <h2>{gettext("Not found!")}</h2>
    </div>
  )
}
